import angular from 'angular'

let configModule = angular.module('app.config', [])
.constant('AppConfig', {
  'default': {
    'type': 'standalone',
    'endpoint': 'https://rcs-eacc-store-api.renault.worldline-solutions.com/api',
    'country': 'ch',
    'locales': [
      'ar',
      'bg',
      'cs',
      'da',
      'de',
      'el',
      'en',
      'es',
      'et',
      'fi',
      'fr',
      'hr',
      'hu',
      'it',
      'lt',
      'lv',
      'nl',
      'pb',
      'pl',
      'pt',
      'ro',
      'ru',
      'sk',
      'sl',
      'sv',
      'tr',
      'uk',
      'zh'
    ],
    'useCache': true,
    'guide': 'http://www.e-guide.renault.com',
    'rlinkModels': [
      {
        'id': 'model1Landscape',
        'title': 'rlink',
        'huType': 'MM12',
        'toolbox': {
          'windowsUrl': 'http://sa.services.solaris.test.tomtom.com/static/rltb/Windows/InstallRLinkToolbox.exe',
          'osxUrl': 'http://sa.services.solaris.test.tomtom.com/static/rltb/Mac/RLinkToolbox.dmg',
          'imageUrl': 'img/toolbox.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink.description'
        },
        'type': 'landscape'
      },
      {
        'id': 'model2Portrait',
        'title': 'rlink2',
        'huType': 'RADNAV',
        'toolbox': {
          'windowsUrl': 'https://stg-rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
          'osxUrl': 'https://stg-rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
          'imageUrl': 'img/toolbox_2.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
        },
        'type': 'portrait'
      },
      {
        'id': 'model2Landscape',
        'title': 'rlink2',
        'huType': 'RADNAV',
        'toolbox': {
          'windowsUrl': 'https://stg-rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
          'osxUrl': 'https://stg-rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
          'imageUrl': 'img/toolbox_2.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
        },
        'type': 'landscape'
      }
    ],
    'googleRecaptchaClientKey': '6LcMcBEUAAAAANcj-ngWfpWhORUdieg0P7eXtZi0',
    'freeProductsOnly': false,
    'currency': 'EUR',
    'passwordExpirationDay': 1080
  },
  'lu': {
    'locales': [
      'fr',
      'en'
    ],
    'trackingIdGA': 'UA-65822765-17'
  },
  're': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-65822765-18'
  },
  'fr': {
    'type': 'helios',
    'locales': [
      'fr',
      'zh'
    ],
    'errorUrl': 'https://fr-fr.dark.uat.heliosrenault.net/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://fr-fr.dark.uat.heliosrenault.net',
    'trackingIdGA': 'UA-65822765-21',
    'gdprLink': 'https://easyconnect.renault.fr/pages/privacy'
  },
  'gr': {
    'OLDlocales': [
      'el',
      'en'
    ],
    'trackingIdGA': 'UA-65822765-2'
  },
  'ua': {
    'locales': [
      'uk',
      'en'
    ],
    'trackingIdGA': 'UA-65822765-3'
  },
  'mx': {
    'OLDlocales': [
      'es',
      'en',
      'ru'
    ],
    'trackingIdGA': 'UA-65822765-4',
    'currency': 'RUB'
  },
  'lv': {
    'locales': [
      'lv'
    ],
    'trackingIdGA': 'UA-65822765-5'
  },
  'lt': {
    'locales': [
      'lt'
    ],
    'trackingIdGA': 'UA-65822765-20'
  },
  'ee': {
    'locales': [
      'et'
    ],
    'trackingIdGA': 'UA-65822765-6'
  },
  'cl': {
    'locales': [
      'es'
    ],
    'trackingIdGA': 'UA-65822765-7',
    'freeProductsOnly': true
  },
  'bg': {
    'locales': [
      'bg'
    ],
    'trackingIdGA': 'UA-65822765-8'
  },
  'ar': {
    'locales': [
      'es'
    ],
    'trackingIdGA': 'UA-65822765-9'
  },
  'br': {
    'locales': [
      'pb'
    ],
    'trackingIdGA': 'UA-65822765-10'
  },
  'co': {
    'locales': [
      'es'
    ],
    'trackingIdGA': 'UA-65822765-1'
  },
  'ae': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-11'
  },
  'bh': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-12'
  },
  'kw': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-13'
  },
  'om': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-14'
  },
  'qa': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-15'
  },
  'sa': {
    'locales': [
      'en',
      'ar',
      'fr',
      'zh'
    ],
    'trackingIdGA': 'UA-65822765-16'
  },
  'tr': {
    'locales': [
      'en',
      'tr'
    ]
  },
  'at': {
    'locales': [
      'de',
      'en',
      'zh'
    ],
    'gdprLink': 'https://easyconnect.renault.at/pages/privacy'
  },
  'ch': {
    'locales': [
      'fr',
      'de',
      'it',
      'en',
      'zh'
    ]
  },
  'de': {
    'type': 'helios',
    'locales': [
      'de',
      'es',
      'zh'
    ],
    'errorUrl': 'https://de-de.dark.uat.heliosrenault.net/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://de-de.dark.uat.heliosrenault.net',
    'gdprLink': 'https://easyconnect.renault.de/pages/privacy'
  },
  'es': {
    'type': 'one',
    'OLDlocales': [
      'es'
    ],
    'errorUrl': 'https://ren-valid-1-euw1.wrd-aws.com/es-dark/es/my/error.action?error=',
    'rootUrl': 'https://ren-valid-1-euw1.wrd-aws.com/es-dark/es/my/r-link-store.html',
    'gdprLink': 'https://easyconnect.renault.es/pages/privacy',
    'trackingIdGA': 'UA-65822765-22'
  },
  'pages': {
    'home': {
      'slides': [
        'photo_001',
        'photo_002',
        'photo_003',
        'photo_004',
        'photo_005',
        'photo_006'
      ],
      'paragraphs': [
        'illustration_01',
        'illustration_02'
      ]
    }
  }
})
.name

export default configModule



// WEBPACK FOOTER //
// ./src-generated/app.config.js